import Question from '../util/question'
import { gameState } from '../util/game_state'
import PlayButton from '../util/play_button'

up.compiler('[audio-multiple-choice]', (element, { name, buttonMode, skipToSolution, completeSlideUrl }) => {
  const question = new Question(element, name)
  const audioElement = element.querySelector('[question--audio]')
  const choices = element.querySelector('[question--choices]')
  const startButton = element.querySelector('[question--start-button]')
  const submitButton = element.querySelector('[question--submit-button]')

  let submitted = false

  up.on(audioElement, 'ended', showChoices)
  up.on(submitButton, 'click', onClickSubmit)
  up.on(element, 'click', '[question--choice-button]', onClickChoice)
  gameState.submit.register(onClickSubmit)

  const playButton = new PlayButton(audioElement, startButton)
  playButton.connect()

  if (skipToSolution) {
    submit()
    showChoices()
    question.skipToSolution()
  }

  function showChoices() {
    if (!submitted) {
      choices.removeAttribute('hidden')

      if (!buttonMode) {
        submitButton.removeAttribute('hidden')
      }
    }
  }

  async function onClickChoice(_event, button) {
    checkChoice(button.dataset.checkboxId)
    await onClickSubmit()
  }

  function checkChoice(answerId) {
    const choiceCheckbox = choices.querySelector(`[id="${answerId}"]`)
    choiceCheckbox.checked = true
  }

  async function onClickSubmit() {
    submit()
    if (completeSlideUrl) {
      await up.request(completeSlideUrl, { method: 'POST' })
    }
    question.checkAnswers()
  }

  function submit() {
    submitButton.remove()
    gameState.stopGame()
    submitted = true
  }

  return function destroy() {
    gameState.submit.unregister(onClickSubmit)
    playButton.disconnect()
    if (!submitted) {
      gameState.stopGame()
    }
  }
})
